import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

const Header: React.FC = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navigate = useNavigate();

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (searchTerm.trim()) {
      navigate(`/search?q=${encodeURIComponent(searchTerm)}`);
    }
  };

  return (
    <header className="sticky top-0 z-20 bg-[var(--background-color)]/80 backdrop-blur-sm border-b border-[var(--border-color)] px-4 md:px-10 py-4 shadow-lg">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-8">
          <Link className="flex items-center gap-3 text-[var(--text-primary)]" to="/">
            <span className="material-symbols-outlined text-3xl md:text-4xl text-[var(--primary-color)]">account_balance</span>
            <h1 className="text-xl md:text-2xl font-black tracking-wider uppercase">Exploring History</h1>
          </Link>
          <nav className="hidden md:flex items-center gap-6">
            <Link className="text-sm font-medium hover:text-[var(--primary-color)] transition-colors" to="/search">
              Articles
            </Link>
            <Link className="text-sm font-medium hover:text-[var(--primary-color)] transition-colors" to="/timeline">
              Timeline
            </Link>
            <Link className="text-sm font-medium hover:text-[var(--primary-color)] transition-colors" to="/maps">
              Maps
            </Link>
          </nav>
        </div>
        
        <div className="flex items-center gap-4">
          <form onSubmit={handleSearch} className="relative hidden sm:block">
            <input 
              className="form-input w-48 lg:w-64 rounded-full border-2 border-[var(--border-color)] bg-transparent py-2 px-4 text-sm focus:border-[var(--primary-color)] focus:ring-0" 
              placeholder="Search History..." 
              type="text"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </form>
          
          <button 
            className="md:hidden flex items-center justify-center size-10 rounded-full border-2 border-[var(--border-color)] hover:border-[var(--primary-color)] transition-colors"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="Toggle menu"
          >
            <span className="material-symbols-outlined text-[var(--text-primary)]">
              {isMobileMenuOpen ? 'close' : 'menu'}
            </span>
          </button>
        </div>
      </div>
      
      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden absolute left-0 right-0 top-full bg-[var(--background-color)] border-b border-[var(--border-color)] shadow-lg">
          <nav className="flex flex-col py-2">
            <Link 
              className="px-4 py-3 text-sm font-medium hover:bg-[var(--surface-color)] hover:text-[var(--primary-color)] transition-colors" 
              to="/search"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Articles
            </Link>
            <Link 
              className="px-4 py-3 text-sm font-medium hover:bg-[var(--surface-color)] hover:text-[var(--primary-color)] transition-colors" 
              to="/timeline"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Timeline
            </Link>
            <Link 
              className="px-4 py-3 text-sm font-medium hover:bg-[var(--surface-color)] hover:text-[var(--primary-color)] transition-colors" 
              to="/maps"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Maps
            </Link>
            <div className="px-4 py-2">
              <form onSubmit={handleSearch} className="relative">
                <input 
                  className="form-input w-full rounded-full border-2 border-[var(--border-color)] bg-transparent py-2 px-4 text-sm focus:border-[var(--primary-color)] focus:ring-0" 
                  placeholder="Search History..." 
                  type="text"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </form>
            </div>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;